import Store from 'store/store';
import { visibleRatio } from 'utils/visibilityChecks';

Store.on('UPDATE_HOME_ACTIVE_PERCENTAGE', () => {
	let elem = document.querySelector('[data-section=boltHome]');
	let percentage = visibleRatio(elem);
	let store = Store.get();
	if (percentage === undefined) {
		return store.set({ homeActivePercentage: 0 });
	}
	store.set({ homeActivePercentage: percentage });
});

Store.on('UPDATE_SCROLL_CONTAINER_HEIGHT', taller => {
	let store = Store.get();
	if (store.scrollerTallerThanWindow !== taller) {
		store.set({ scrollerTallerThanWindow: taller });
	}
});

Store.on('UPDATE_VISIBILITY_PERCENTAGES', () => Store.emit('UPDATE_HOME_ACTIVE_PERCENTAGE'));
